import React, {useEffect, useState} from "react";
import {Nullable} from "modules/types";
import styled from "@emotion/styled";
import {useSelector} from "react-redux";
import {getActiveContestCategory, getStatByPlayerId} from "modules/selectors";
import {prepareStatToRender} from "modules/utils/helpers";

const Wrapper = styled.div`
	position: relative;
	width: 46px;
	height: 46px;
`;

const StatsSpan = styled.span`
	position: absolute;
	left: 0;
	top: 0;
	font-weight: 800 !important;
	font-size: 40px !important;
	line-height: 38px !important;

	@keyframes rotate-text-up {
		0%,
		50% {
			transform: translate3d(0, 0, 0);
			opacity: 1;
		}

		100% {
			transform: translate3d(0, -40px, 0);
			opacity: 0;
		}
	}

	@keyframes fade-text-in {
		0% {
			opacity: 0;
			transform: translate3d(0, 80px, 0);
		}

		50%,
		100% {
			opacity: 1;
			transform: translate3d(0, 0, 0);
		}
	}

	&.fade-out {
		animation: 0.25s rotate-text-up forwards;
	}

	&.fade-in-before {
		opacity: 0;
	}

	&.fade-in {
		animation: fade-text-in 0.5s 0.25s forwards;
	}
`;

interface IProps {
	playerId: Nullable<number>;
}

export const PlayerStat: React.FC<IProps> = ({playerId}) => {
	const [isAnimated, setIsAnimated] = useState(true);
	const stat = useSelector(getStatByPlayerId)(playerId);
	const category = useSelector(getActiveContestCategory);

	useEffect(() => {
		if (stat === null) {
			setIsAnimated(false);
			return;
		}
		setIsAnimated(true);
	}, [stat]);

	const noStatsClass = isAnimated ? "fade-out" : "";
	const yesStatsClass = isAnimated ? "fade-in" : "";

	return (
		<Wrapper>
			<StatsSpan className={noStatsClass}>?</StatsSpan>
			<StatsSpan className={`${yesStatsClass} fade-in-before`}>
				{prepareStatToRender(stat, category)}
			</StatsSpan>
		</Wrapper>
	);
};
